'use client';

import { c as _c } from "react/compiler-runtime";
import { useState } from 'react';
import { FilterIcon } from '@/components/atoms/Icons';
import { useExplore } from './ExploreProvider';
import { SearchInput } from './SearchInput';
import { FilterModal } from './FilterModal';
import { LocationFinder } from './LocationFinder';
import { HeartsScopeToggle } from './HeartsScopeToggle';

/**
 * Composable header component for explore views
 * Contains: SearchInput + FilterButton + LocationFinder
 *
 * Variants:
 * - floating: Absolute positioned, used over map/photos views
 * - inline: Static positioned, used in list view header
 */
export function ExploreHeader(t0) {
  const $ = _c(23);
  const {
    variant: t1,
    showFilterButton: t2,
    showLocationButton: t3,
    className: t4,
    searchWrapperClass: t5,
    id: t6
  } = t0;
  const variant = t1 === undefined ? "floating" : t1;
  const showFilterButton = t2 === undefined ? true : t2;
  const showLocationButton = t3 === undefined ? true : t3;
  const className = t4 === undefined ? "" : t4;
  const searchWrapperClass = t5 === undefined ? "" : t5;
  const id = t6 === undefined ? "" : t6;
  const {
    getActiveFilterCount
  } = useExplore();
  const [isFilterModalOpen, setIsFilterModalOpen] = useState(false);
  const containerClasses = variant === "floating" ? `absolute top-4 left-4 right-4 z-10 ${className}` : `${className}`;
  const t7 = `${containerClasses} ${searchWrapperClass}`;
  let t8;
  if ($[0] !== id) {
    t8 = <SearchInput id={id} className="flex-1" serchInputClass="!lg:pr-31 md:!text-base !text-[15px] !shadow-[-2px_2px_20px_0_rgba(0,0,0,0.1)] max-w-[calc(100%-105px)] lg:max-w-full" searchClass="right-26 lg:right-23 pr-2 bg-red text-[#D9D9D9]" />;
    $[0] = id;
    $[1] = t8;
  } else {
    t8 = $[1];
  }
  let t9;
  if ($[2] !== getActiveFilterCount || $[3] !== showFilterButton) {
    t9 = showFilterButton && <button onClick={() => setIsFilterModalOpen(true)} className="!absolute h-full !lg:border-r lg:border-l border-t-0 border-b-0 rounded-[10px] lg:rounded-none px-3 cursor-pointer border-[#D9D9D9] right-13 lg:right-11 bg-white !lg:bg-transparent !shadow-none" aria-label="Open filters"><FilterIcon className="w-5 h-5 text-[#A8A8A8]" />{getActiveFilterCount() > 0 && <span className="absolute top-2.25 right-1 w-3 h-3 rounded-full bg-[#00EAFD]" style={{
        backgroundColor: "#00EAFD"
      }} suppressHydrationWarning={true} />}</button>;
    $[2] = getActiveFilterCount;
    $[3] = showFilterButton;
    $[4] = t9;
  } else {
    t9 = $[4];
  }
  let t10;
  if ($[5] !== showLocationButton) {
    t10 = showLocationButton && <LocationFinder className="absolute right-0" />;
    $[5] = showLocationButton;
    $[6] = t10;
  } else {
    t10 = $[6];
  }
  let t11;
  if ($[7] !== t10 || $[8] !== t8 || $[9] !== t9) {
    t11 = <div className="flex items-center relative">{t8}{t9}{t10}</div>;
    $[7] = t10;
    $[8] = t8;
    $[9] = t9;
    $[10] = t11;
  } else {
    t11 = $[10];
  }
  let t12;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <HeartsScopeToggle />;
    $[11] = t12;
  } else {
    t12 = $[11];
  }
  let t13;
  if ($[12] !== t11) {
    t13 = <div className="relative space-y-2.5">{t11}{t12}</div>;
    $[12] = t11;
    $[13] = t13;
  } else {
    t13 = $[13];
  }
  let t14;
  if ($[14] !== t13 || $[15] !== t7) {
    t14 = <div className={t7}>{t13}</div>;
    $[14] = t13;
    $[15] = t7;
    $[16] = t14;
  } else {
    t14 = $[16];
  }
  let t15;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = () => setIsFilterModalOpen(false);
    $[17] = t15;
  } else {
    t15 = $[17];
  }
  let t16;
  if ($[18] !== isFilterModalOpen) {
    t16 = <FilterModal isOpen={isFilterModalOpen} onClose={t15} />;
    $[18] = isFilterModalOpen;
    $[19] = t16;
  } else {
    t16 = $[19];
  }
  let t17;
  if ($[20] !== t14 || $[21] !== t16) {
    t17 = <>{t14}{t16}</>;
    $[20] = t14;
    $[21] = t16;
    $[22] = t17;
  } else {
    t17 = $[22];
  }
  return t17;
}

/**
 * Inline header variant for list view - full width with different styling
 */
export function ExploreHeaderInline(t0) {
  const $ = _c(5);
  const {
    className: t1,
    id: t2
  } = t0;
  const className = t1 === undefined ? "" : t1;
  const id = t2 === undefined ? "" : t2;
  const t3 = `bg-white border-b border-gray-200 px-4 py-3 ${className}`;
  let t4;
  if ($[0] !== id) {
    t4 = <ExploreHeader variant="inline" className="max-w-none" id={id} />;
    $[0] = id;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  let t5;
  if ($[2] !== t3 || $[3] !== t4) {
    t5 = <div className={t3}>{t4}</div>;
    $[2] = t3;
    $[3] = t4;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  return t5;
}